    /**
     * Created by shubham on 28/2/18.
     * Updated by neha on 03/02/26.
     */

    import { Component } from '@angular/core';
    import { SessionHandler } from '../shared/services/session-handler.service';
    import { HttpService } from '../shared/services/http.service';
    import { LayoutService } from '../layout/layout.service';
    import { APPCONFIG } from '../config';
    import { MdDialog } from '@angular/material';
    import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
    import { Router, ActivatedRoute } from '@angular/router';
    import { DaterangepickerConfig } from 'ng2-daterangepicker';
    import { DialogComponent } from '../dialog/dialog.component';
    import { RegistrationDialogComponent } from '../dialog/dialog.component';
    import { TranslateService } from 'ng2-translate';

    @Component({
        template: require('./registration.component.html')
    })

    export class RegistrationComponent {
        dialogRef;
        RegistrationForm: FormGroup;
        RegistrationFormDetails: any;
        RegistrationDataById = [];
        CountryAndBusinessUnitDataById = [];
        Countries = [];
        BusinessUnit = [];
        isApplicationRemovable = true;
        Applications = [];
        emailPattern = APPCONFIG.emailPattern;
        //passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{5,}$/;
        passwordPattern = /^(?=[A-Za-z])(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[~@$%^&*_\-+‘|=(){}\[\]:;‘"\\<>,.\/])[A-Za-z0-9~@$%^&*_\-+‘|=(){}\[\]:;‘"\\<>,.\/]{16,40}$/;
        phoneNumberPattern = /^[+]?([0-9]*[\.\s\-\(\)]|[0-9]+){3,7}$/;
        //phoneNumberPattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        customerNumberLength: number = 0;
        LanguageData: any;
        urlId: any;
        urlIdFlag: boolean = false;
        appsUrlIdFlag: boolean = false;
        passwordErrorMsg: string = '';

        constructor(private route: ActivatedRoute, private router: Router,public httpService : HttpService, public layoutService : LayoutService,
                    private dialog: MdDialog, private formBuilder: FormBuilder, private daterangepickerOptions: DaterangepickerConfig,
                    public sessionHandler : SessionHandler, private translate: TranslateService){

            //Get URL param value
            this.route.params.subscribe(params => {
                this.urlId = params['id'];
                this.getLanguages();

                if(this.urlId != undefined || this.urlId != null){
                    this.urlIdFlag = true;

                    if(router.url.indexOf("apps") > -1) {
                        this.appsUrlIdFlag = true;
                        this.getCountryAndBusinessUnitById(this.urlId);
                    } else {
                        this.getCountries();
                        this.getBusinessUnit();
                        this.getRegistrationDataById(this.urlId);
                    }
                } else{
                    this.urlIdFlag = false;
                    this.getCountries();
                }
            });
        }

        public getCountries() {
            this.httpService.getRequest('lookupDataOperationsApi/v1/country').subscribe(
                res => { this.saveCountries(res); },
                err => { this.httpService.onEnd(); }
            );
        }
        
        validateName(event: any) {
            return APPCONFIG.validNameRegex.test(event.key);
        }
        saveCountries(res) {
            if(res && res.items){
                this.Countries = res.items;
            }
            this.httpService.onEnd();
        }

        public getBusinessUnit() {
            this.httpService.getRequest('lookupDataOperationsApi/v1/businessUnit').subscribe(
                res => { this.saveBusinessUnits(res); },
                err => { this.httpService.onEnd(); }
            );
        }
        saveBusinessUnits(res) {
            if(res && res.items){
                this.BusinessUnit = res.items;
            }
            this.httpService.onEnd();
        }

        public getLanguages() {
            this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(
                res => { this.saveLanguageResponse(res); },
                err => { this.httpService.onEnd(); }
            );
        }
        saveLanguageResponse(res) {
            if(res && res.items){
                this.LanguageData = res.items;
            }
            this.httpService.onEnd();
        }

        public getBusinessUnitByCountryId(countryId) {
            this.httpService.getRequest('lookupDataOperationsApi/v1/businessUnitForCountry/'+countryId).subscribe(
                res => { this.saveBusinessUnitByCountryId(res); },
                err => { this.httpService.onEnd(); }
            );
        }
        saveBusinessUnitByCountryId(res) {
            if(res && res.items){
                this.BusinessUnit = res.items;
            }
            this.httpService.onEnd();
        }

        public getApplicationsByCountryAndBusinessUnit(countryId, businessUnitId) {
            this.httpService.getRequest('applicationOperationApi/v1/getApplicationForbusinessUnit?countryId='+countryId+'&businessUnitId='+businessUnitId).subscribe(
                res => { this.saveApplicationsByCountryAndBusinessUnit(res); },
                err => { this.httpService.onEnd(); }
            );
        }
        saveApplicationsByCountryAndBusinessUnit(res) {
            if(res && res.items){
                this.Applications = res.items;
                this.createRoles(this.Applications);
            }
            this.httpService.onEnd();
        }

        getCountryAndBusinessUnitById(urlId){
            this.httpService.getRequest('/applicationOperationApi/v1/getbusinessUnitCountryForApplication?id='+urlId).subscribe(
                res => { this.saveCountryAndBusinessUnitById(res); },
                err => { this.httpService.onEnd(); }
            );
        }
        saveCountryAndBusinessUnitById(res){
            this.CountryAndBusinessUnitDataById = res;
            if(this.CountryAndBusinessUnitDataById){
                this.Countries = this.CountryAndBusinessUnitDataById['countryList'];
            }
            this.httpService.onEnd();
        }

        public getRegistrationDataById(urlId){
            this.httpService.getRequest('/userRegistrationsApi/v1/migratedUserDetails/'+urlId).subscribe(
                res => { this.saveRegistrationData(res); },
                err => { this.httpService.onEnd(); }
            );
        }
        saveRegistrationData(res){
            if(res){
                this.RegistrationDataById = res;
                this.RegistrationForm.controls['email'].disable();
                this.RegistrationForm.controls['countryId'].disable();
                this.RegistrationForm.controls['businessUnitId'].disable();
                this.RegistrationForm.controls['companyName'].disable();
                this.RegistrationForm.controls['customerNumber'].disable();
                $('#exampleInputNewPassword').focus();
                this.buildForm();

                // Now get all the applications
                if(!res.selectedApplications) {
                    this.getApplicationsByCountryAndBusinessUnit(this.RegistrationDataById['countryId'], this.RegistrationDataById['businessUnitId']);
                }else {
                    this.isApplicationRemovable = false;
                    //Case where roles are already assigned to the migrated user 
                    res.items = res.selectedApplications;
                    this.saveApplicationsByCountryAndBusinessUnit(res);
                }
            }
        }

        buildForm() {
            this.RegistrationForm = this.formBuilder.group({
                firstName: this.formBuilder.control(this.RegistrationDataById['firstName']?this.RegistrationDataById['firstName']:null, [Validators.required]),
                lastName: this.formBuilder.control(this.RegistrationDataById['lastName']?this.RegistrationDataById['lastName']:null, [Validators.required]),
                password: this.formBuilder.control('', [Validators.required,Validators.minLength(16),Validators.maxLength(40),Validators.pattern(this.passwordPattern),this.noPersonalInfoValidator.bind(this)]),
                confirmPassword: this.formBuilder.control('', [Validators.required]),
                email: this.formBuilder.control(this.RegistrationDataById['email']?this.RegistrationDataById['email']:null, [Validators.required, Validators.pattern(this.emailPattern)]),
                countryId: this.formBuilder.control(this.RegistrationDataById['countryId']?this.RegistrationDataById['countryId']:null, [Validators.required]),
                businessUnitId: this.formBuilder.control(this.RegistrationDataById['businessUnitId']?this.RegistrationDataById['businessUnitId']:null, [Validators.required]),
                companyName: this.formBuilder.control(this.RegistrationDataById['companyName']?this.RegistrationDataById['companyName']:null, [Validators.required]),
                companyAddress: this.formBuilder.control(this.RegistrationDataById['companyAddress']?this.RegistrationDataById['companyAddress']:null, [Validators.required]),
                customerNumber: this.formBuilder.control(this.RegistrationDataById['customerNumber']?this.RegistrationDataById['customerNumber']:null),
                companyPhone: this.formBuilder.control(this.RegistrationDataById['companyPhone']?this.RegistrationDataById['companyPhone']:null, [Validators.pattern(this.phoneNumberPattern)]),
                languageId: this.formBuilder.control(this.RegistrationDataById['languageId']?this.RegistrationDataById['languageId']:null),
                applications: this.formBuilder.array([])
            },  {validator: this.checkPasswords});
            this.RegistrationForm.valueChanges.subscribe(data => {
                this.RegistrationFormDetails = this.RegistrationForm.getRawValue();
                if(this.urlIdFlag){
                    this.RegistrationFormDetails['migratedFrom'] = this.RegistrationDataById['id'];
                }

                this.RegistrationFormDetails.validate = this.RegistrationForm.valid;
            });

            this.RegistrationForm.get('countryId').valueChanges.subscribe(data=> {
                if(!this.urlIdFlag || this.appsUrlIdFlag){
                    this.RegistrationForm.controls['businessUnitId'].setValue(null);
                    this.BusinessUnit = [];

                    if(!this.urlIdFlag && data != null){
                        this.getBusinessUnitByCountryId(data);
                    } else if(this.appsUrlIdFlag && data != null){
                        for(let countryData of this.CountryAndBusinessUnitDataById['countryList']){
                            if(countryData && countryData['id'] && data == countryData['id'] && countryData['businessUnitList']){
                                this.BusinessUnit = countryData['businessUnitList'];
                            }
                        }
                    }
                }
            });

            this.RegistrationForm.get('businessUnitId').valueChanges.subscribe(data=> {
                if(!this.urlIdFlag || this.appsUrlIdFlag){
                    const arrayControl = <FormArray>this.RegistrationForm.controls['applications'];
                    arrayControl.controls = [];
                    this.Applications = [];

                    if(!this.urlIdFlag && data != null){
                        this.getApplicationsByCountryAndBusinessUnit(this.RegistrationForm.get('countryId').value,data);
                    } else if(this.appsUrlIdFlag && data != null){
                        this.Applications.push(this.CountryAndBusinessUnitDataById);
                        this.createRoles(this.Applications);
                    }
                }
            });

            this.RegistrationForm.get('customerNumber').valueChanges.subscribe(data=> {
                if(data != null){
                    this.customerNumberLength = data.toString().length;
                }
            });

            this.RegistrationForm.get('languageId').valueChanges.subscribe(data=> {
                if(data != null){
                    this.sessionHandler.saveItem("languageId", data);
                    this.translate.setDefaultLang(data);
                    this.translate.use(data);
                }
            })

            this.RegistrationForm.get('password').valueChanges.subscribe(data => {
        if (!data) return;

        if (data.length < 16 || data.length > 40) {
            this.passwordErrorMsg = "Minimum of 16 characters and maximum of 40 characters long";
        } else if (!/^[A-Za-z]/.test(data)) {
            this.passwordErrorMsg = "First character must be an alphabet";
        } else if (!/[A-Z]/.test(data)) {
            this.passwordErrorMsg = "Contain at least one uppercase character (A–Z)";
        } else if (!/[a-z]/.test(data)) {
            this.passwordErrorMsg = "Contain at least one lowercase character (a–z)";
        } else if (!/[0-9]/.test(data)) {
            this.passwordErrorMsg = "Contain at least one numeric character (0–9)";
        } else if (!/[~@$%^&*_\-+‘|=(){}\[\]:;‘"\\<>,.\/]/.test(data)) {
            this.passwordErrorMsg =   'Contain at least one special character (~ @ $ % ^ & * _ - + | = ( ) { } [ ] : ; " \\ < > , . /)';
        } else if (this.RegistrationForm.get('password').hasError('personalInfo')) {
            this.passwordErrorMsg = "Should not contain your first name, last name, or user id";
        } else {
            this.passwordErrorMsg = "";
        }
    });

        }
    noPersonalInfoValidator(control: any) {
        if (!control || !control.value || !this.RegistrationForm) return null;
        var password = control.value.toLowerCase();
        var firstNameCtrl = this.RegistrationForm.get('firstName');
        var lastNameCtrl = this.RegistrationForm.get('lastName');
        var emailCtrl = this.RegistrationForm.get('email');
        var firstName = firstNameCtrl && firstNameCtrl.value
            ? firstNameCtrl.value.toLowerCase()
            : '';
        var lastName = lastNameCtrl && lastNameCtrl.value
            ? lastNameCtrl.value.toLowerCase()
            : '';
        var email = emailCtrl && emailCtrl.value
            ? emailCtrl.value.toLowerCase()
            : '';
        var emailUser = email.indexOf('@') > -1 ? email.split('@')[0] : '';
        if (
            (firstName && password.indexOf(firstName) > -1) ||
            (lastName && password.indexOf(lastName) > -1) ||
            (emailUser && password.indexOf(emailUser) > -1)
        ) {
            return { personalInfo: true };
        }
        return null;
    }

        checkPasswords(group: FormGroup) {
            if(group.get('password').value === group.get('confirmPassword').value){
                group.get('confirmPassword').setErrors(null);
                return null;
            } else{
                group.get('confirmPassword').setErrors({'incorrect': true});
                return {'mismatch': true};
            }
        }

        showPassword(input: any): any {
            input.type = input.type === 'password' ?  'text' : 'password';
        }

        createRoles(applicationsData): void{
            for(let data of applicationsData){
                this.onAddApplicationsProperty(data);
            }
        }
        public onAddApplicationsProperty(data?: any): void {
            const arrayControl = <FormArray>this.RegistrationForm.controls['applications'];
            let newGroup;
            if(data){
                newGroup = this.formBuilder.group({
                    applicationId: this.formBuilder.control(data.id?data.id:null),
                    applicationName: this.formBuilder.control({value: data.applicationName?data.applicationName:null, disabled: true}, [Validators.required]),
                    /*customerNumber: this.formBuilder.control(null),
                    customerNumberCheck: this.formBuilder.control(data.customerNumberRequired?data.customerNumberRequired:false)*/
                }, /*{validator: this.ChangeValidator}*/);
            } else {
                newGroup = this.formBuilder.group({
                    applicationId: this.formBuilder.control(null),
                    applicationName: this.formBuilder.control(null, [Validators.required]),
                    /*customerNumber: this.formBuilder.control(null),
                    customerNumberCheck: this.formBuilder.control(true)*/
                });
            }
            arrayControl.push(newGroup);
        }

        /*ChangeValidator(group: FormGroup){
            if(group.get('customerNumberCheck').value){
                group.get('customerNumber').setValidators([Validators.required]);
            } else{
                group.get('customerNumber').setValidators(null);
            }
            return null;
        }*/

        onDeleteRoleProperty(index: number): void {
            const arrayControl = <FormArray>this.RegistrationForm.controls['applications'];
            arrayControl.removeAt(index);
        }

        saveData() {
            if(this.RegistrationFormDetails){
                this.httpService.postRequest(this.RegistrationFormDetails,'userRegistrationsApi/v1/register/serviceOwner').subscribe(
                    res => { this.saveResponse(res); },
                    err => { this.httpService.onEnd(); }
                );
            } else {
                this.layoutService.popToast("Invalid Email Domain.", APPCONFIG.toastrType.error);
            }
        }
        public saveResponse(res){
            if(res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(DialogComponent);
                this.dialogRef.componentInstance.msg = 'User is not authorized';
            } else {
                let email = res.email;
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(RegistrationDialogComponent);
                if(this.urlIdFlag){
                    this.dialogRef.componentInstance.msg = "after_registration_notify";
                } else {
                    this.dialogRef.componentInstance.msg = "registration_rqst_notify";
                }
                this.dialogRef.afterClosed().subscribe(result => {
                    this.router.navigateByUrl('/login');
                });
            }
        }

        ngOnInit(): void {
            this.buildForm();
        }
    }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/registration/registration.component.ts